var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { injectable } from 'inversify';
import { Logger } from '../logger';
import initializeCades from './cadesplugin_api';
let Crypto = class Crypto {
    constructor(logger) {
        this.logger = logger;
        this.plugin = null;
        this.store = null;
        this.certificates = null;
        this.cryptoType = undefined;
    }
    getCertificates(type) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.certificates &&
                this.certificates.length &&
                this.cryptoType === type) {
                return this.certificates;
            }
            this.certificates = [];
            this.cryptoType = type;
            const plugin = this.getPlugin();
            yield this.init(plugin);
            const store = yield this.getStore();
            try {
                if (type === 'cades') {
                    store.Open(plugin.CADESCOM_CONTAINER_STORE);
                }
                else {
                    store.Open(plugin.CAPICOM_CURRENT_USER_STORE, plugin.CAPICOM_MY_STORE, plugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED);
                }
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'store.open',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка открытия хранилища');
            }
            try {
                const certificates = yield store.Certificates;
                const validCertificates = yield certificates.Find(plugin.CAPICOM_CERTIFICATE_FIND_TIME_VALID);
                const count = yield validCertificates.Count;
                if (count !== undefined) {
                    for (let i = 1; i <= count; i += 1) {
                        this.certificates.push(yield validCertificates.Item(i));
                    }
                }
                yield store.Close();
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'store.certificates',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка получения списка сертификатов');
            }
            if (!this.certificates.length) {
                this.logger.info('[crypto] No certificates', {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'certificates.empty',
                    },
                });
                /* istanbul ignore next */
                throw new Error('Сертификаты не найдены');
            }
            return this.certificates;
        });
    }
    /**
     * Создать hash переданного файла по алгоритму CP_GOST_3411_2012_256
     *
     * @param blob - Файл
     * @returns Хэш файла в виде строки
     */
    createHash(blob) {
        return __awaiter(this, void 0, void 0, function* () {
            const plugin = this.getPlugin();
            yield this.init(plugin);
            const blobToBase64 = () => {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result.split('base64,')[1]);
                    reader.readAsDataURL(blob);
                });
            };
            try {
                const hashed = yield plugin.CreateObjectAsync('CAdESCOM.HashedData');
                yield hashed.propset_Algorithm(plugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256);
                yield hashed.propset_DataEncoding(plugin.CADESCOM_BASE64_TO_BINARY);
                yield hashed.Hash(yield blobToBase64());
                return yield hashed.Value;
            }
            catch (error) {
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при хешировании');
            }
        });
    }
    /**
     * Подготовить массив объектов, которые отображают информацию о сертификатах
     *
     * @param cryptoType - Тип криптографии (cades или capicom)
     * @returns Массив объектов с информацией о сертификатах
     */
    getSerializedCertificates(cryptoType) {
        return __awaiter(this, void 0, void 0, function* () {
            const certificates = yield this.getCertificates(cryptoType);
            const parseDN = (dnString) => {
                const resultObj = {};
                dnString
                    .split(/, (?=[a-zA-Zа-яА-ЯёЁ0-9\.]+=)/)
                    .map((item) => item.split('='))
                    .forEach((item) => {
                    let value = item[1];
                    if ((value === null || value === void 0 ? void 0 : value.startsWith('"')) && (value === null || value === void 0 ? void 0 : value.endsWith('"'))) {
                        value = value.slice(1, -1);
                        value = value.replace(/""/g, '"');
                    }
                    resultObj[item[0].trim()] = value;
                });
                return resultObj;
            };
            try {
                const result = yield Promise.all(certificates.map((certificate) => __awaiter(this, void 0, void 0, function* () {
                    const subjectName = yield certificate.SubjectName;
                    const issuerName = yield certificate.IssuerName;
                    const subjectNameObj = parseDN(subjectName);
                    const issuerNameObj = parseDN(issuerName);
                    return {
                        id: yield certificate.SerialNumber,
                        name: subjectNameObj.CN,
                        user: subjectNameObj.CN || '-',
                        company: subjectNameObj.O || '-',
                        activeFrom: yield certificate.ValidFromDate,
                        activeTo: yield certificate.ValidToDate,
                        issuerName: issuerNameObj.CN || '-',
                    };
                })));
                return result;
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'certificate.serialization',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка сериализации сертификатов');
            }
        });
    }
    extractMeaningfulErrorMessage(error) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(error instanceof Error)) {
                return null;
            }
            const plugin = this.getPlugin();
            yield this.init(plugin);
            let errorMessage = plugin.getLastError ? plugin.getLastError(error) : '';
            if (!errorMessage) {
                if (!error.message) {
                    return null;
                }
                errorMessage = error.message;
            }
            const containsRussianLetters = /[а-яА-Я]/.test(errorMessage);
            if (!containsRussianLetters) {
                return null;
            }
            const searchResult = errorMessage.match(/^(.*?)(?:(?:\.?\s?\(?0x)|(?:\.?$))/);
            return searchResult ? searchResult[1] : null;
        });
    }
    createSigner(certificate, tsp) {
        return __awaiter(this, void 0, void 0, function* () {
            const plugin = this.getPlugin();
            yield this.init(plugin);
            let timeAttr;
            let documentNameAttr;
            let signer;
            try {
                signer = yield plugin.CreateObjectAsync('CAdESCOM.CPSigner');
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'plugin.signer',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при инициализации подписи');
            }
            try {
                timeAttr = yield plugin.CreateObjectAsync('CADESCOM.CPAttribute');
                yield timeAttr.propset_Name(plugin.CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME);
                yield timeAttr.propset_Value(new Date());
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'plugin.time_attribute',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при установке времени подписи');
            }
            try {
                documentNameAttr = yield plugin.CreateObjectAsync('CADESCOM.CPAttribute');
                yield documentNameAttr.propset_Name(plugin.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME);
                yield documentNameAttr.propset_Value('');
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'plugin.name_attribute',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при установке имени файла');
            }
            try {
                yield signer.propset_Certificate(certificate);
                yield signer.propset_CheckCertificate(true);
                if (tsp) {
                    yield signer.propset_TSAAddress(tsp);
                }
                const authAttrs = yield signer.AuthenticatedAttributes2;
                yield authAttrs.Add(timeAttr);
                yield authAttrs.Add(documentNameAttr);
                yield signer.propset_Options(plugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN);
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'signer.certificate',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при установке сертификата подписи');
            }
            return signer;
        });
    }
    /**
     * Подписать hash документа указанным сертификатом
     *
     * @param certificate - Сертификат, используемый для подписания
     * @param hash - Hash документа
     * @param tsp - Сервис меток точного времени
     * @returns Подпись в виде строки
     */
    signHash(certificate, hash, tsp) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = yield this.createSigner(certificate, tsp);
            const plugin = this.getPlugin();
            yield this.init(plugin);
            let hashedData;
            let signedData;
            try {
                signedData = yield plugin.CreateObjectAsync('CAdESCOM.CadesSignedData');
                yield signedData.propset_ContentEncoding(plugin.CADESCOM_BASE64_TO_BINARY);
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'signedData.encoding',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при создании усовершенствованной подписи');
            }
            try {
                hashedData = yield plugin.CreateObjectAsync('CAdESCOM.HashedData');
                yield hashedData.propset_Algorithm(plugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256);
                yield hashedData.SetHashValue(hash);
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'hashedData.value',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при установке хэша подписи');
            }
            try {
                const signature = yield signedData.SignHash(hashedData, signer, !!tsp ? plugin.CADESCOM_CADES_X_LONG_TYPE_1 : plugin.CADESCOM_CADES_BES);
                return signature;
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'signedData.sign',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при подписании данных');
            }
        });
    }
    /**
     * Найти сертификат по id среди имеющихся в системе
     *
     * @param id - Id сертификата (серийный номер сертификата)
     * @param cryptoType - Тип криптографии (cades или capicom)
     * @returns Сертификат
     */
    getSertificateById(id, cryptoType) {
        return __awaiter(this, void 0, void 0, function* () {
            const certificates = yield this.getCertificates(cryptoType);
            let result;
            try {
                result = (yield Promise.all(certificates.map((certificate) => __awaiter(this, void 0, void 0, function* () {
                    return ({
                        id: yield certificate.SerialNumber,
                        certificate,
                    });
                })))).find((certificate) => certificate.id === id);
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'certificate.serial_number',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при подписании данных');
            }
            if (!result) {
                this.logger.error('[crypto] Unknown certificate', {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'certificate.serial_number',
                    },
                });
                /* istanbul ignore next */
                throw new Error('Переданный сертификат не существует');
            }
            return result.certificate;
        });
    }
    getStore() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.store) {
                return this.store;
            }
            const plugin = this.getPlugin();
            yield this.init(plugin);
            try {
                this.store = yield plugin.CreateObjectAsync('CAdESCOM.Store');
                return this.store;
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'plugin.store',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error((yield this.extractMeaningfulErrorMessage(error)) ||
                    'Ошибка при попытке доступа к хранилищу');
            }
        });
    }
    init(plugin) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield plugin;
            }
            catch (error) {
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'crypto',
                        crypto_type: 'plugin.initialization',
                    },
                    context: {
                        crypto_error: error,
                    },
                });
                /* istanbul ignore next */
                throw new Error('Ошибка инициализации cades плагина');
            }
        });
    }
    getPlugin() {
        if (this.plugin) {
            return this.plugin;
        }
        initializeCades();
        if (!window.cadesplugin) {
            this.logger.info('[crypto] No plugin', {
                tags: {
                    vkdoc_error_type: 'crypto',
                    crypto_type: 'plugin.not_intalled',
                },
            });
            /* istanbul ignore next */
            throw new Error('Cades плагин не найден');
        }
        this.plugin = window.cadesplugin;
        return this.plugin;
    }
};
Crypto = __decorate([
    injectable(),
    __metadata("design:paramtypes", [Logger])
], Crypto);
export { Crypto };
